import { useEffect } from 'react';

import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useGetEmployerIdParam } from '../../hooks';
import { useBaseReportSummaryQuery } from '../../queries';
import { DelinquentClaimsSummaryReportParams } from '../DelinquentClaimsReport.types';

export const QUERY_KEY = 'GET_REPORT_DELINQUENT_CLAIMS_SUMMARY';

const useDelinquentClaimsReportSummaryQuery = (params: DelinquentClaimsSummaryReportParams) => {
  const getEmployerIdParam = useGetEmployerIdParam();

  const {
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isEmptyData,
    lastTimeUpdateDate,
    planOptions,
    isEmptyPlanOptions,
    isHasNextPage,
    handleLoadMore,
    resetPagination,
  } = useBaseReportSummaryQuery(
    params.isMultipleEmployer
      ? API_URL.REPORTS_DELINQUENT_CLAIMS_REPORT_MULTI_EMPLOYERS_SUMMARY
      : API_URL.REPORTS_DELINQUENT_CLAIMS_REPORT_SUMMARY,
    [
      QUERY_KEY,
      params.employerId,
      params.accountTypes?.join(','),
      params.planIds?.join(','),
      params.planYearPeriod?.join(','),
      params.employerIds?.join(','),
    ],
    {
      ...getEmployerIdParam(params.employerId, params.employerIds),
      account_types:
        params.accountTypes && !params.accountTypes.includes(ALL_OPTION_KEY)
          ? params.accountTypes.join(',')
          : undefined,
      plan_ids:
        !params.isMultipleEmployer && params.planIds && !params.planIds.includes(ALL_OPTION_KEY)
          ? params.planIds.join(',')
          : undefined,
      plan_year_period:
        params.planYearPeriod && !params.planYearPeriod.includes(ALL_OPTION_KEY)
          ? params.planYearPeriod.join(',')
          : undefined,
    },
    {
      isMultipleEmployers: params.isMultipleEmployer,
      employerId: params.employerId,
      employerIds: params.employerIds,
    }
  );

  const accountTypesKey = params.accountTypes?.join(',');
  const planIdsKey = params.planIds?.join(',');
  const planYearPeriodKey = params.planYearPeriod?.join(',');
  const employerIdsKey = params.employerIds?.join(',');

  useEffect(() => {
    resetPagination();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.employerId, accountTypesKey, planIdsKey, planYearPeriodKey, employerIdsKey]);

  return {
    lastTimeUpdateDate,
    planOptions,
    isEmptyPlanOptions,
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isEmptyData,
    isHasNextPage,
    handleLoadMore,
  };
};

export default useDelinquentClaimsReportSummaryQuery;
